import React, { useEffect, useState } from "react";
import Slide from "component/common/Slider";
import LeftArray from "assets/images/leftArrow.png";
import RightArray from "../../../assets/images/RightArrow.svg";
import * as APIS from "../../../service/apis/products.apis";
import { history } from "redux/store/store";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from "react-icons/md"
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);
function slideFun(arr = []) {
  return (
    arr
      // .sort(() => Math.random() - 0.5)
      .map((x , index) => {
        return (
          <span onClick={() => productData(x?.id)} key={index}>
            {/* <a href="/category" className="text-reset text-decoration-none"> */}
            <img
              src={x.image.url}
              className="mx-auto"
              alt="images"
              style={{ height: "76px" }}
            />
            <p className="text-center mb-0 pt-3 text-grey-7e">{x.title}</p>
            {/* <p className="text-center m-0">{x.segment}</p> */}
            {/* </a> */}
          </span>
        );
      })
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${RightArray})`,
        backgroundRepeat: "no-repeat",
        display: "block",
        content: "none",
        width: "3.75rem",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${LeftArray})`,
        backgroundRepeat: "no-repeat",
        display: "block",
        content: "none",
        width: "3.75rem",
      }}
      onClick={onClick}
    />
  );
}
let productData = async (id) => {
  // console.log(id, "iffff");

  let products = await APIS.GetProductsByCategory({ categoryId: id });
  // console.log(products, "pppppppppppppp");
  // alert('aaaaaaaa')
  history.push(`/category?id=${id}`);
  // setProducts(products);
  // setKey(id);
};
export const Slider = function (props) {
  const [key, setKey] = useState("");
  const [products, setProducts] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showInput, setshowInput] = useState(false);
  const [begin, setBegin] = useState(true);

  const [end, setEnd] = useState(false);
  async function temp() {
    let result = await APIS.GetCategories();
    setCategories(result);
    let prducts = await APIS.ProductSearch({ search: "*" });
    if (prducts.length)
      prducts = prducts.map((x) => ({ label: x.node.title, value: x.node.id }));
    setProductsList(prducts);
    // console.log("prducts", prducts);
  }

  useEffect(() => {
    temp();
  }, []);

  const swiperOptions = {
    initialSlide: 0,
    navigation: {
      nextEl: "#relatedMedicineNext",
      prevEl: "#relatedMedicinePrev",
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
      },
      400: {
        slidesPerView: 2,
      },
      600: {
        slidesPerView: 2,
      },
      750: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  };

  const handleSlide = (event) => {
    setBegin(event.isBeginning);
    setEnd(event.isEnd);
  };

  // console.log(props, "props");
  let settings = {
    dots: false,
    infinite: true,
    slidesToShow: 9,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div id="slider" className="py-5 mx-auto">
      <h5 className="text-center font-weight-600 py-sm-5 pb-4">
        Shop by Trending Categories
      </h5>
      <div className="forwardArrow d-md-none d-block">
        <div className="arrowBg" id="relatedMedicinePrev">
          <MdOutlineArrowBackIosNew size={20} />
        </div>
      </div>
      <div className="d-md-block d-none">
        <div className="d-flex justify-content-end mb-4">
          <div id="relatedMedicinePrev" className="cursor-pointer">
            <img src={LeftArray} alt=''/>
          </div>
          <div id="relatedMedicineNext" className="cursor-pointer ml-3">
            <img src={RightArray} alt='' />
          </div>
        </div>
      </div>
      <Swiper
        {...swiperOptions}
        className="slideWrapperHome"
        onSlideChange={handleSlide}
      >
        {categories.map((x, index) => {
          return (
            <SwiperSlide key={index}>
              <div
                className="d-flex flex-column justify-content-center cursor-pointer"
                onClick={() => productData(x?.id)}
              >
                {/* <a href="/category" className="text-reset text-decoration-none"> */}
                <img
                  src={x.image.url}
                  className="mx-auto"
                  alt="images"
                  style={{ height: "76px" }}
                />
                <p className="text-center mb-0 pt-3 text-grey-7e">{x.title}</p>
                {/* <p className="text-center m-0">{x.segment}</p> */}
                {/* </a> */}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="backwardArrow d-md-none d-block">
        <div className="arrowBg " id="relatedMedicineNext">
          <MdOutlineArrowForwardIos size={20} />
        </div>
      </div>
      {/* <Slide slideData={slideFun(categories)} settings={settings} /> */}
      {/* <span className="py-sm-4 py-2 d-block"></span> */}
    </div>
  );
};
